import * as yup from 'yup'
import {
  PASSWORD_HAS_DIGIT,
  PASSWORD_HAS_LOWER,
  PASSWORD_HAS_SPECIAL,
  PASSWORD_HAS_UPPER,
  PASSWORD_MIN_LENGTH,
} from 'utils/passwordRules'

export interface ITextRequired {
  messageRequired?: string
}

export interface IEmailSchema extends ITextRequired {
  messageEmail?: string
}

export const emailSchema = (
  payload: IEmailSchema = {
    messageEmail: 'signin.emailMessageValidError',
    messageRequired: 'signin.emailRequiredError',
  }
) => yup.string().email(payload.messageEmail).required(payload.messageRequired)

export const passwordSchema = (payload: ITextRequired = { messageRequired: 'signin.passwordRequiredError' }) =>
  yup.string().required(payload.messageRequired)

export const newPasswordSchema = (payload: ITextRequired = { messageRequired: 'signin.passwordRequiredError' }) =>
  yup
    .string()
    .required(payload.messageRequired)
    .min(PASSWORD_MIN_LENGTH, 'password.min_length')
    .test('password-lower', 'password.need_lowercase', value => PASSWORD_HAS_LOWER.test(value || ''))
    .test('password-upper', 'password.need_uppercase', value => PASSWORD_HAS_UPPER.test(value || ''))
    .test('password-digit', 'password.need_digit', value => PASSWORD_HAS_DIGIT.test(value || ''))
    .test('password-special', 'password.need_special', value => PASSWORD_HAS_SPECIAL.test(value || ''))
